import api from './api';

const patientService = {
  // Crear perfil de paciente
  createProfile: async (data) => {
    const response = await api.post('/patients', data);
    return response.data;
  },

  // Obtener mi perfil
  getMyProfile: async () => {
    const response = await api.get('/patients/me');
    return response.data;
  },

  // Actualizar perfil
  updateProfile: async (id, data) => {
    const response = await api.put(`/patients/${id}`, data);
    return response.data;
  }
};

export default patientService;
